import EventBus from '../EventBus'

export default {
    methods: {
        messageDialog: function (text, onOk) {
            EventBus.$emit('MessageDialogOpen', { text: text, onOk: onOk})
        },
    }
}